var render = function render(_c,_vm){return _c('div',{staticClass:"comp-kind-chip chip chip-secondary text-uppercase d-inline-flex align-items-center gap-2"},[_c('b-icon',{attrs:{"icon":_vm.props.kind.icon,"variant":"primary"}}),_c('span',{staticClass:"font-size-70"},[_vm._v(_vm._s(_vm.props.kind.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }